import React, { useEffect, useState } from 'react';
import { number, string } from 'prop-types';

import classes from './LoadProgressBar.module.css';

const LoadProgressBar = ({
    currentValue,
    hidden,
    label,
    maxValue,
    ...props
}) => {

    const [percentage, setPercentage] = useState(0);

    useEffect(() => {
        if (currentValue) {
            setPercentage((currentValue / maxValue) * 100);
        }
    }, [currentValue]);

    useEffect(() => {
        return () => {
            setPercentage(0);
        };
    }, []);

    if (hidden) return null;

    return (
        <div className={classes.LoadProgressBar}>
            <div className={classes.wrapper}>
                <div className={classes.label}>
                    <span>{currentValue} / {maxValue} {label}</span>
                </div>
                <div className={classes.filler} style={{ width: `${percentage}%` }} />
            </div>
        </div>
    );
};

LoadProgressBar.defaultProps = {
    currentValue: 0,
    label:        '',
    maxValue:     100
};

LoadProgressBar.propTypes = {
    currentValue: number,
    label:        string,
    maxValue:     number
};

export default LoadProgressBar;
